import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/swiper-bundle.css'
import router from './router'
import store from './store'
import i18n from './lang' // 引入 i18n 配置

Vue.config.productionTip = false

Vue.use(ElementUI);


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
